
// Stage 1 inputs options
export const incomeOptions= [ 
    {
        label: '<5,000',
        value: '2500'
    },
    {
        label: '5,000-9,000',
        value: '7000'
    },
    {
        label: '9,000-14,000',
        value: '11500'
    },
    {
        label: '14,000-20,000',
        value: '17000'
    },
    {
        label: '>20,000',
        value: '35000'
    },
];
export const expenditureOptions= [ 
    {
        // label: '<1,350',
        label: '<1,300',
        value:  '1254' 
    },
    {
        // label: '1,350-1,628',
        label: '1,300-1,600',
        value: '1489'
    },
    {
        // label: '1,628-2,100',
        label: '1,600-2,100',
        value: '1864'
    },
    {
        // label: '2,100-2,503',
        label: '2,100-2,500',
        value: '2301'
    },
    {
        // label: '>2,503',
        label: '>2,500',
        value: '3843'
    },
];
export const householdOptions= [ 
    {
        label:  '1',
        value:  '1' 
    },
    {
        label: '2',
        value: '2'
    },
    {
        label: '3',
        value: '3'
    },
    {
        label: '4',
        value: '4'
    },
    {
        label: '5',
        value: '5'
    },
];


// Stage 2 inputs options
export const eatoutOptions= [ 
    {
        label: '<500',
        value: '250'
    },
    {
        label: '500-800',
        value: '650'
    },
    {
        label: '800-1,000',
        value: '900'
    },
    {
        label: '1,000-1,200',
        value: '1100'
    },
    {
        label: '>1,200',
        value: '1300'
    },
];
export const utilsOptions= [ 
    {
        label: '<100',
        value:  '50' 
    },
    {
        label: '100-150',
        value: '125'
    },
    {
        label: '150-250',
        value: '200'
    },
    {
        label: '250-350',
        value: '300'
    },
    {
        label: '>350',
        value: '400'
    },
];
export const transportRecreationOptions= [ 
    {
        label:  '<250',
        value:  '100' 
    },
    {
        label: '250-500',
        value: '375'
    },
    {
        label: '500-750',
        value: '625'
    },
    {
        label: '750-1,000',
        value: '875'
    },
    {
        label: '1,000-1,500',
        value: '1250'
    },
    {
        label: '1,500-2,000',
        value: '1750'
    },
    {
        label: '2,000-4,000',
        value: '3000'
    },
    {
        label: '4,000-8,000',
        value: '6000'
    },
    {
        label: '>8,000',
        value: '10000'
    },
];